import React from "react"
import ReactDOM from "react-dom"
import "assets/css/main.css"
import AppContainer from "containers/App/AppContainer"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import "translates/config"
console.log("v1.2.46")

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()
